import PropTypes from 'prop-types';
import React from 'react';
import Flexbox from 'flexbox-react';
import RetrievalRulesTable from 'components/page/process/variableRetrieval/inputs/RetrievalRulesTable';


/**
 * Displays the retrieval rules table showing all retrieval rules in the process
 */
export default class RetrievalRulesForm extends React.Component {
    static propTypes = {
        process: PropTypes.object,
        hasWritePermissions: PropTypes.bool,
        siteFacilities: PropTypes.array,
        dods: PropTypes.array,
        dodsById: PropTypes.object,
        processErrors: PropTypes.object
    };

    render() {
        const inputDatasets = this.props.process.variable_retrieval.input_datasets;

        return (
            <Flexbox className="retrieval-rules-form " flexDirection="row" flexGrow={1}>
                <Flexbox className="entity-box retrieval-rules-table" flexDirection="column" flexGrow={1} width="100%">
                    <Flexbox flexDirection="row" flexGrow={1} width="100%">
                        <RetrievalRulesTable
                            className="retrieval-rules-table"
                            process={this.props.process}
                            inputDatasetNames={Object.keys(inputDatasets)}
                            dods={this.props.dods}
                            dodsById={this.props.dodsById}
                            siteFacilities={this.props.siteFacilities}
                            hasWritePermissions={this.props.hasWritePermissions}
                            processErrors={this.props.processErrors}
                        />
                    </Flexbox>
                </Flexbox>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/page/process/variableRetrieval/RetrievalRulesForm.js